import { useMemo } from "react";

import {
    LpTopComponentVersionA,
    LpTopComponentVersionB,
    LpTopComponentVersionC,
    LpTopComponentVersionD,
    LpTopComponentVersionE,
    LpTopComponentVersionF,
    LpTopComponentVersionG,
    LpTopComponentVersionH,
} from "@/src/cashback/LandingPage/Version/index";

export function CashbackABTest({ variant }: { variant: string }) {
    const forceVersion: string | null = null;
    const version = useMemo(() => forceVersion ?? variant, [variant]);

    switch (version) {
        case "VariantB":
            return <LpTopComponentVersionB />;
        case "VariantC":
            return <LpTopComponentVersionC />;
        case "VariantD":
            return <LpTopComponentVersionD />;
        case "VariantE":
            return <LpTopComponentVersionE />;
        case "VariantF":
            return <LpTopComponentVersionF />;
        case "VariantG":
            return <LpTopComponentVersionG />;
        case "VariantH":
            return <LpTopComponentVersionH />;
        case "VariantA":
            return <LpTopComponentVersionA isVariant />;
        case "Control":
        default:
            return <LpTopComponentVersionA />;
    }
}
